<div>
	<h2 class="titulo">Item</h2>
	<mat-divider class="divider-margin"></mat-divider>
	<br>
	<div class="image-container">
		@if (!imagensCarregadas) {
		<div class="divSpinner">
			<mat-spinner class="spinner"></mat-spinner>
		</div>
		}
		@if (imagensCarregadas) {
		<swiper-container
			[attr.navigation]="imageObject.length > 1 || null"
			style="display: block; width: 100%; height: 180px;">
			@for (image of imageObject; track $index) {
			<swiper-slide>
				<img [src]="image.thumbImage" (click)="ampliarImagem($index)"
					style="width: 100%; height: 180px; object-fit: contain; cursor: zoom-in;">
			</swiper-slide>
			}
		</swiper-container>
		}
	</div>
	<form class="form-item-descricao">
		<mat-form-field class="field-width-100 cor">
			<mat-label>Descrição</mat-label>
			<input matInput disabled [(ngModel)]="item.itemDetalhes.nmItem" name="nmItem">
		</mat-form-field>
		<br>
		@if (item.itemDetalhes.cdItem !== undefined && item.itemDetalhes.cdItem.length > 0) {
		<mat-form-field class="field-width-25 campo-esquerdo cor">
			<mat-label>Cd. Item</mat-label>
		<b><input matInput disabled [(ngModel)]="item.itemDetalhes.cdItem" name="cdItem"></b>
		</mat-form-field>
		}
		@if (item.itemDetalhes.cdOriginal !== undefined && item.itemDetalhes.cdOriginal.length > 0) {
		<mat-form-field class="field-width-25 campo-esquerdo cor">
			<mat-label>Cd. Original</mat-label>
			<input matInput disabled [(ngModel)]="item.itemDetalhes.cdOriginal" name="cdOriginal">
		</mat-form-field>
		}
		@if (item.itemDetalhes.cdFabricante !== undefined && item.itemDetalhes.cdFabricante.length > 0) {
		<mat-form-field class="campo-esquerdo cor"
			[ngClass]="(item.itemDetalhes.nmMarca !== undefined && item.itemDetalhes.nmMarca.length > 0) ? 'field-width-50':'field-width-25'"
			>
			<mat-label>Cd. Fabricante</mat-label>
			<input matInput disabled [(ngModel)]="item.itemDetalhes.cdFabricante" name="cdFabricante">
		</mat-form-field>
		}
		@if (item.itemDetalhes.nmMarca !== undefined && item.itemDetalhes.nmMarca.length > 0) {
		<mat-form-field class="campo-esquerdo cor"
			[ngClass]="(item.itemDetalhes.cdFabricante !== undefined && item.itemDetalhes.cdFabricante.length > 0) ? 'field-width-50':'field-width-25'"
			>
			<mat-label>Marca</mat-label>
			<input matInput disabled [(ngModel)]="item.itemDetalhes.nmMarca" name="nmMarca">
		</mat-form-field>
		}
	</form>
</div>
